import React, { Component } from 'react'
import styled from 'styled-components'

import DivisionNavbarItem from 'components/DivisionNavbarItem'

class DivisionNavbar extends Component {
  render() {
    const { className, divisions, selected, onClick } = this.props
    return (
      <Container className={className}>
        {divisions &&
          divisions.map((division, index) => (
            <DivisionNavbarItem
              key={`division-${index}`}
              onClick={() => onClick(division)}
              icon={division.icon}
              title={division.name}
              selected={selected.id === division.id}
            />
          ))}
      </Container>
    )
  }
}

export default DivisionNavbar

const Container = styled.div`
  display: flex;
  min-width: 100px;
  margin: 0;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 50%;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  transform: translateX(-50%);
`



// WEBPACK FOOTER //
// ./src/containers/DivisionNavbar/index.js